// extracted by mini-css-extract-plugin
module.exports = {"accessDeniedPage":"accessDeniedPage--E6+h5","imageBox":"imageBox--tQ2Gd","titleBox":"titleBox--f4hH6","title":"title--OHwaK","subTitle":"subTitle--xkz-o"};